module.exports = __webpack_public_path__ + "img/full0-min.dd849608.png";